(function () {
	'use strict';

	angular
		.module('app.core')
		.service('myWorkService', myWorkService);

	myWorkService.$inject = ['$http', 'URLS'];

	function myWorkService($http, URLS) {
		var self = this;
		self.selectedTask = {};
		self.selectedProject = {};
		var service = {
			getProjectTask: getProjectTask,
			updateProjectTask: updateProjectTask,
			getProjectIssue: getProjectIssue,
			updateProjectIssue: updateProjectIssue,
			getProject: getProject,
			setProject: setProject,
			getTask: getTask,
			setTask: setTask
		};
		return service;

		function getProjectTask(taskNdx, projectNdx, factoryNdx) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/Task/' + taskNdx;
			return $http.get(url)
				.then(getProjectTaskSuccess)
				.catch(getProjectTaskFailed);

			function getProjectTaskSuccess(response) {
				return response;
			}

			function getProjectTaskFailed(error) {
				return error;
			}
		}

		function updateProjectTask(taskObj, projectNdx, factoryNdx, lastModified) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/Task/' + taskObj.ndx;
			return $http.put(url, taskObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(updateProjectTaskSuccess)
				.catch(updateProjectTaskFailed);

			function updateProjectTaskSuccess(response) {
				return response;
			}

			function updateProjectTaskFailed(error) {
				return error;
			}
		}

		function getProjectIssue(issueNdx, projectNdx, factoryNdx) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/Issue/' + issueNdx;
			return $http.get(url)
				.then(getProjectIssueSuccess)
				.catch(getProjectIssueFailed);

			function getProjectIssueSuccess(response) {
				return response;
			}

			function getProjectIssueFailed(error) {
				return error;
			}
		}

		function updateProjectIssue(issueObj, projectNdx, factoryNdx, lastModified) {
			var url = URLS.host + URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/Issue/' + issueObj.ndx;
			return $http.put(url, issueObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(updateProjectIssueSuccess)
				.catch(updateProjectIssueFailed);

			function updateProjectIssueSuccess(response) {
				return response;
			}

			function updateProjectIssueFailed(error) {
				return error;
			}
		}

		function getProject() {
			return self.selectedProject;
		}

		function setProject(project) {
			self.selectedProject = project;
		}

		function getTask() {
			return self.selectedTask;
		}

		function setTask(task) {
			self.selectedTask = task;
		}
	}

})();
